import { render, staticRenderFns } from "./StorageStock.vue?vue&type=template&id=5b8849e6&"
import script from "./StorageStock.vue?vue&type=script&lang=js&"
export * from "./StorageStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports